var map = {
	"./fancy-letters.directive.js": 567
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;


//////////////////
// WEBPACK FOOTER
// ./src/directives nonrecursive .+\.directive\.js$
// module id = 566
// module chunks = 1